import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getLatestMessage, removeMessage, clearMessages} from 'redux-flash';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {Icon} from './Icon';

class FlashMessages extends Component {
    constructor(props) {
        super(props);

        this.closeMessage = this.closeMessage.bind(this);
    }

    componentWillUnmount() {
        const {dispatch} = this.props;

        dispatch(clearMessages());
    }

    closeMessage(e, id) {
        e.preventDefault();

        const {dispatch} = this.props;

        dispatch(removeMessage(id));
    }

    render() {
        const {flash, withContainer} = this.props;

        if (!flash) {
            return null;
        }

        return (
            <div
                id="flash-messages"
                className={classNamesPrefixed({
                    'flash-messages': true,
                    'with-container': withContainer,
                    'success': flash && flash.props && flash.props.type === 'success',
                    'error': flash && flash.props && flash.props.type === 'error',
                    'warning': flash && flash.props && flash.props.type === 'warning',
                    'publish': flash && flash.props && flash.props.type === 'publish'
                })}
            >
                {flash &&
                <div>
                    <div className="flash-message">
                        {flash.props && flash.props.type === 'publish' &&
                            <Icon type={"fal"} name={"info-circle"} />
                        }
                        {flash.message}
                    </div>
                    <a href="#close-flash-message" onClick={(e) => this.closeMessage(e, flash.id)}>
                        <Icon type={"fal"} name={"times"}/>
                    </a>
                </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        flash: getLatestMessage(state)
    };
}

export default connect(mapStateToProps)(FlashMessages);


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/FlashMessages.js